import { useMutation, gql } from "@apollo/client";
import { CartItemFragment } from "../components/cart/CartItem";
import useDebounce from "../../common/utils/useDebounce";

const UpdateCartItemMutation = gql`
  mutation UpdateCartItem($itemId: ID!, $quantity: Int) {
    updateCartItem(itemId: $itemId, quantity: $quantity) {
      ...CartItemFragment
    }
  }
  ${CartItemFragment}
`;

const useUpdateCartItem = () => {
  const [updateCartItemMutation, { client }] = useMutation(
    UpdateCartItemMutation,
  );
  const debouncedUpdateCartItemMutation = useDebounce(
    updateCartItemMutation,
    300,
  );

  const updateCartItem = async ({ itemId, quantity }) => {
    client.writeFragment({
      id: `OrderItem:${itemId}`,
      fragment: gql`
        fragment AdjustedOrderItem on OrderItem {
          quantity
        }
      `,
      data: {
        quantity: quantity,
      },
    });

    await debouncedUpdateCartItemMutation({
      variables: { itemId, quantity },
      refetchQueries: ["ClientCart"],
    });
  };

  return {
    updateCartItem,
  };
};

export default useUpdateCartItem;
